export default function R_GetStarted() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_GetStarted Component</h1>
      <p>This is the R_GetStarted tutorial section.</p>
    </div>
  );
}
